import { ENVIROMENTAL_VARIABLES } from 'Constants/enviromentalVariables'

import type { SessionExpiryCheckDependencies } from './sessionExpiry.types'

const SESSION_PROBE_PATH = `/api/${ENVIROMENTAL_VARIABLES.API_VERSION}/auth/user/me`

/**
 * Symfony answers an expired session with a redirect to the login page, not with 401.
 */
const isSessionExpired = (response: Response): boolean =>
  response.type === 'opaqueredirect' || response.status === 401

export const createSessionExpiryCheck = ({
  probe,
  reload,
}: SessionExpiryCheckDependencies) => {
  let isEnabled = false
  let isRunning = false

  return {
    enable: () => {
      isEnabled = true
    },
    reloadIfExpired: (): Promise<void> => {
      if (!isEnabled || isRunning) {
        return Promise.resolve()
      }

      isRunning = true

      return (
        probe()
          .then(isSessionExpired)
          // An unreachable server says nothing about the session, so the user stays on the page.
          .catch(() => false)
          .then(isExpired => {
            if (isExpired) {
              reload()
            }

            // A reload cancelled in a beforeunload prompt keeps the page, so later failures check again.
            isRunning = false
          })
      )
    },
  }
}

export const sessionExpiryCheck = createSessionExpiryCheck({
  probe: () => fetch(SESSION_PROBE_PATH, { redirect: 'manual' }),
  reload: () => window.location.reload(),
})
